import { atomWithLocalStorage } from "../comments/comments";


const CANVAS_VIEW_OPTION_LOCAL_STORAGE_KEY = "canvasViewOptions";

interface ICanvasViewOptions {
    showSkinnyCanvas: boolean;
    showCommentCount: boolean;
    showLinkedInsightsCount: boolean;
    showLinkedHypothesesCount: boolean;
    showHypothesesIndication:boolean;
}

const INITIAL_OPTIONS: ICanvasViewOptions = {
    showSkinnyCanvas: false,
    showCommentCount: false,
    showLinkedInsightsCount: true,
    showLinkedHypothesesCount: false,
    showHypothesesIndication:true,
};

export const canvasViewOptionsAtom = atomWithLocalStorage(
    CANVAS_VIEW_OPTION_LOCAL_STORAGE_KEY,
    INITIAL_OPTIONS,
    []
);
